import React from "react";
import {
  Grid,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { useFormContext, useWatch } from "react-hook-form";

import RadioTabs from "../../components/RadioTabs/RadioTabs";
import FlightBadge from "../../components/FlightBadge/FlightBadge";
import FlightDetails from "./organisms/FlightDetails";
import { CustomSwitch } from "../../components/Switch/Switch";
import FormOperator from "../../components/FormOperator/FormOperator";
import AccomodationCard from "../../components/AccomodationCard/AccomodationCard";
import NextButton from "../../components/NextButton/NextButton";
import useStyles from "./styles";
import { warning } from "../../constants/colors"
import Accreditation from "../../components/Accreditation/Accreditation";

export default function Step1({
  handleNext,
  activeStep,
  apiData,
  tipsValue,
  selectedFlight,
  priceQuoteId,
}) {
  const classes = useStyles();
  const theme = useTheme();
  const { getValues, setValue } = useFormContext();
  const show = useMediaQuery(theme.breakpoints.down("sm"));

  const quoteUnavailable = selectedFlight.active_till && Math.round(Date.now()/1000) > selectedFlight.active_till;


  const is_sold = !!selectedFlight?.is_sold;

  React.useEffect(() => {
    if (quoteUnavailable) {
      setValue("itinerarySwitch", false);
    }
    if (is_sold) {
      setValue("itinerarySwitch", false);
    }
  }, [quoteUnavailable, is_sold]);

  const itinerarySwitchValue =
    useWatch({
      name: "itinerarySwitch",
    }) || getValues("itinerarySwitch");

  const flightValue =
    useWatch({
      name: "flight",
    }) ||
    getValues("flight") ||
    priceQuoteId;

  return (
    <Grid container style={{ height: "100%" }}>
      <Grid item xs={12} md={8} className={classes.mainForm}>
        <Box mb={2.5}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            className={classes.formHeader}
          >
            <Typography variant="h3" align="center">
              Please choose your preferred flight option
            </Typography>
            <Typography variant="body1" align="center">
              A few simple steps
            </Typography>
          </Box>
        </Box>
        <Box mb={2.5}>
          <Grid container spacing={1}>
            <RadioTabs
              name="flight"
              options={apiData?.priceQuotes}
              airlines={apiData?.airlines}
              selectedFlight={selectedFlight}
            />
          </Grid>
        </Box>
        <Box
          mb={2.5}
          display="flex"
          justifyContent="center"
          className={classes.ticketHeader}
        >
          <Box display="flex" alignItems="center">
            <Typography variant="h2">Flight Details</Typography>
            {selectedFlight?.badge && (
              <Box ml={1}>
                <FlightBadge info={selectedFlight?.badge} withLabel={true} />
              </Box>
            )}
          </Box>
        </Box>
        <Box>
          <Grid container>
          {selectedFlight?.parts?.hasOwnProperty('depart') && Object.keys(selectedFlight?.parts?.depart)?.length > 0 && (
              <FlightDetails
                type="depart"
                flightDetail={selectedFlight?.parts?.depart}
                flightNumber="1"
                badge={selectedFlight?.badge}
                airlines={apiData?.airlines}
                airports={apiData?.airports}
              />
            )}
            {selectedFlight?.parts?.hasOwnProperty('return') && Object.keys(selectedFlight?.parts?.return)?.length > 0 && (
              <FlightDetails
                type="return"
                flightDetail={selectedFlight?.parts?.return}
                flightNumber="1"
                airlines={apiData?.airlines}
                airports={apiData?.airports}
              />
            )}
            {selectedFlight?.parts?.multiple?.map((part, index) => (
              <FlightDetails
                type="multiple"
                flightDetail={part}
                flightNumber={index + 1}
                airlines={apiData?.airlines}
                airports={apiData?.airports}
              />
            ))}
          </Grid>
        </Box>
        {selectedFlight?.accomodation && (
          <Box>
            <Box
              mb={2.5}
              display="flex"
              justifyContent="center"
              className={classes.ticketHeader}
            >
              <Box display="flex" alignItems="center">
                <Typography variant="h2">Hotel Details</Typography>
              </Box>
            </Box>
            <AccomodationCard accomodationInfo={selectedFlight?.accomodation} />
          </Box>
        )}
      </Grid>
      <Grid
        container
        item
        xs={12}
        md={4}
        className={classes.secondaryForm}
        justify="center"
        alignItems="center"
      >
        {!quoteUnavailable && (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            mb={1}
            className={classes.itinerarySection}
          >
            <Box>
              <Typography variant="h2" align="center">
                Booking almost completed
              </Typography>
            </Box>
            <Box mb={1.5}>
              <Typography variant="body1" align="center">
                Double check your itinerary and click confirm
              </Typography>
            </Box>
            <CustomSwitch
              disabled={is_sold}
              name="itinerarySwitch"
              value={itinerarySwitchValue}
              label="I confirm this itinerary"
            />
            {
              is_sold && (
                <div style={{marginTop: "10px", color: warning}}>The offer has already been sold</div>
              )
            }
            {!show && (
              <Box mt={2}>
                <NextButton
                  selectedFlight={selectedFlight}
                  handleNext={() => {
                    if (is_sold) {
                      return
                    }
                    handleNext();
                  }}
                  disabled={activeStep === 0 && !itinerarySwitchValue}
                  location="form"
                  tipsValue={tipsValue}
                />
              </Box>
            )}
          </Box>
        )}

        <Box width={1}>
          <FormOperator operatorInfo={apiData?.operatorInfo} quoteUnavailable={quoteUnavailable} />
          <Accreditation />
        </Box>
      </Grid>
    </Grid>
  );
}
